<template>


<div  class="col-lg-12 col-7 py-2">
  <ResidentialMenu v-if="isResidential"></ResidentialMenu>
  <EnterpriseMenu v-if="isEnterpriseAdmin || isEnterpriseUser"></EnterpriseMenu>
</div>
</template>

<script>

    import ResidentialMenu from "./ResidentialMenu"
    import EnterpriseMenu from "./EnterpriseMenu"
    import {mapGetters} from "vuex"

  export default {
    name: 'user-menu',
    components: {
        ResidentialMenu,
        EnterpriseMenu
    },
    computed : {
      ...mapGetters({
      isNTAdmin : "Auth/isNTAdmin",
      isNTBackoffice : "Auth/isNTBackoffice",
      isEnterpriseAdmin : "Auth/isEnterpriseAdmin",
      isEnterpriseUser : "Auth/isEnterpriseUser",
      isResidential : "Auth/isResidential",
    }),

    },
    mouted(){
      console.log("User Menu")
      console.log(route.meta)

    },
    methods: {
      getBreadName(route) {
        return route.name;
      }
    }
  };
</script>

<style scoped></style>
